<script lang="ts">
	import Home from '$lib/components/Home.svelte'
</script>

<Home />
